import { AVAILABLE_USER_LANGUAGES } from './languages.const';

addUserLanguagesBoxController.$inject = ['$scope', '$mdDialog', '$translate', 'elementView'];
export function addUserLanguagesBoxController($scope, $mdDialog, $translate, elementView) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.languages = [];
  $scope.list = [];

  _ngOnInit();

  function ok() {
    const data = $scope.languages.map(lang => ({
      lang,
      label: $translate.instant(AVAILABLE_USER_LANGUAGES[lang])
    }));
    $mdDialog.hide({ type: 'ok', data });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function _ngOnInit() {
    const selected = elementView.model.getEmbeddedCells().map(child => child.get('elementData').lang);
    $scope.list =
      Object.keys(AVAILABLE_USER_LANGUAGES)
        .filter(key => !selected.includes(key))
        .map((key) => ({
          id: key,
          label: $translate.instant(AVAILABLE_USER_LANGUAGES[key])
        }));
  }
}
